import React from 'react'

const LocationSchedule = ({location, isRemoteRental = false}) => {
    const dayLabels = {
        1: 'maandag',
        2: 'dinsdag',
        3: 'woensdag',
        4: 'donderdag',
        5: 'vrijdag',
        6: 'zaterdag',
        7: 'zondag'
    }

    const formatTime = (hour, minute) => {
        if (hour === null || hour === undefined || minute === null || minute === undefined) {
            return ''
        }
        const hh = String(hour).padStart(2, '0')
        const mm = String(minute).padStart(2, '0')
        return `${hh}:${mm}`
    }

    const schedule = (location?.schedule || [
        {dayOfWeek: 1, openHour: 8, openMinute: 0, closeHour: 17, closeMinute: 0, isOpen24h: false, isClosed: false},
        {dayOfWeek: 2, openHour: 8, openMinute: 0, closeHour: 17, closeMinute: 0, isOpen24h: false, isClosed: false},
        {dayOfWeek: 3, openHour: 8, openMinute: 0, closeHour: 17, closeMinute: 0, isOpen24h: false, isClosed: false},
        {dayOfWeek: 4, openHour: 8, openMinute: 0, closeHour: 17, closeMinute: 0, isOpen24h: false, isClosed: false},
        {dayOfWeek: 5, openHour: 8, openMinute: 0, closeHour: 17, closeMinute: 0, isOpen24h: false, isClosed: false},
        {dayOfWeek: 6, openHour: 8, openMinute: 0, closeHour: 11, closeMinute: 0, isOpen24h: false, isClosed: false},
        {dayOfWeek: 7, openHour: 8, openMinute: 0, closeHour: 11, closeMinute: 0, isOpen24h: false, isClosed: false}
    ]).map((entry) => {
        const day = dayLabels[entry.dayOfWeek] || 'onbekend'
        let time = ''
        if (entry.isClosed) {
            time = 'Gesloten'
        } else if (entry.isOpen24h) {
            time = '24 uur'
        } else {
            const open = formatTime(entry.openHour, entry.openMinute)
            const close = formatTime(entry.closeHour, entry.closeMinute)
            time = open && close ? `${open}-${close}` : ''
        }
        return {day, time}
    })
    const streetLine = [location?.address?.street, location?.address?.houseNumber, location?.address?.houseNumberExtension]
        .filter(Boolean)
        .join(' ')
    const cityLine = [location?.address?.zipCode, location?.address?.city]
        .filter(Boolean)
        .join(' ')
    const lat = location?.coordinates?.lat
    const lng = location?.coordinates?.lng
    const addressQuery = encodeURIComponent(
        [streetLine, cityLine, location?.address?.country].filter(Boolean).join(', ')
    )
    const mapsUrl = lat && lng
        ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
        : `https://www.google.com/maps/search/?api=1&query=${addressQuery}`
    const remoteTitle = location?.remoteRentalTitle || 'Verhuur op afstand'
    const remoteSubtitle = `Pick up Point ${location?.address?.street || ''} ${location?.address?.houseNumber || ''}`.trim()
    const availability = location?.availabilityNote || 'Callcenter 07:00 tot 24:00'

    const isMobileViewport =
        typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;

    console.log(isMobileViewport)

    return (
        <div className="front-location-schedule">
            <div className="front-location-schedule__left">
                <h3>{location?.company?.name || 'Autohopper Amsterdam Diemen'}</h3>
                <p>{streetLine || 'Piersonstraat 11'}</p>
                <p>{cityLine || '1112 AV Amsterdam Diemen'}</p>

                <div className="front-location-schedule__contact">
                    <a href={`mailto:${location?.email || 'info@kav2go.nl'}`}>
                        <i className="bi bi-envelope"></i>
                        {location?.email || 'info@kav2go.nl'}
                    </a>
                    <a href={`tel:${location?.phone || '0880883434'}`}>
                        <i className="bi bi-telephone"></i>
                        {location?.phone || '088 - 088 34 34'}
                    </a>
                    <div className="front-location-schedule__availability">
                        {availability}
                    </div>
                </div>

                <a
                    className="front-location-schedule__btn"
                    href={mapsUrl}
                    rel="noreferrer"
                >
                    Routebeschrijving
                    <i className="bi bi-chevron-right"></i>
                </a>
            </div>

            <div className="front-location-schedule__right">
                <h4>
                    {
                        location.website ?
                            <a style={{color: 'var(--kav-red)'}} href={location.website} target={isMobileViewport ? '_self' : "_blank"} rel="nofollow">Openingstijden</a>
                            :
                            "Openingstijden"
                    }

                </h4>
                <div className="front-location-schedule__table">
                    {schedule.map((row) => (
                        <div className="front-location-schedule__row" key={row.day}>
                            <span>{row.day}:</span>
                            <strong>{row.time}</strong>
                        </div>
                    ))}
                </div>
            </div>

            {isRemoteRental && (
                <div className="front-location-schedule__third">
                    <h4>{remoteTitle}</h4>
                    <p>{remoteSubtitle}</p>
                </div>
            )}
        </div>
    )
}

export default LocationSchedule
